import styles from 'styles/modules/FormWithSidebar.module.scss';
import Checkbox from './Checkbox';
import Input from './Input';
import Button from './Button';
import Box from './Box';
import Quote from './Quote';
import { useRouter } from 'next/router';
import BoxTopTip from './BoxTopTip';
import {
    GoogleReCaptchaProvider,
    useGoogleReCaptcha,
} from 'react-google-recaptcha-v3';
import { useCallback } from 'react';
import AddressSearch from './AddressSearch';

const FormWithSidebar = (props) => {
    const router = useRouter();
    const { executeRecaptcha } = useGoogleReCaptcha();

    const { data } = props;
    const { form, sidebar, errors, controls } = data;

    const reCaptchaOnSubmitProxy = useCallback(
        async (e) => {
            e.preventDefault();
            if (!executeRecaptcha) {
                console.log('Execute recaptcha not yet available');
                return;
            }

            const token = await executeRecaptcha();
            form?.setValue?.('captchaToken', token);
            form?.onSubmit?.();
        },
        [executeRecaptcha, form?.id, form?.onSubmit, form?.setValue]
    );

    if (!data) return null;

    // todo: refactor this Button - no 'data'
    const inputs = data.form.inputs.map((item, key) => {
        if (item.component === 'button') {
            return (
                <Button
                    {...item}
                    key={`formWithSidebar-${key}`}
                    loading={data.form.loading}
                    theme={'secondary'}
                />
            );
        } else if (item.component === 'checkbox') {
            return (
                <Checkbox
                    {...item}
                    className={styles.checkbox}
                    key={`formWithSidebar-${key}`}
                />
            );
        } else if (item.name === 'fullAddress') {
            return <AddressSearch {...item} key={`formWithSidebar-${key}`} />;
        } else {
            return <Input {...item} key={`formWithSidebar-${key}`} />;
        }
    });

    return (
        <div className={styles.wrapper}>
            <div style={{ width: '100%' }}>
                {form.controls && (
                    <div className={styles.controls}>
                        <a
                            href="/register/profile"
                            className={
                                router.pathname == '/register/profile'
                                    ? [
                                          styles['controls__item'],
                                          styles['controls__item--active'],
                                      ].join(' ')
                                    : styles['controls__item']
                            }
                        >
                            Newspager
                        </a>
                        <a
                            href="/register/journalist"
                            className={
                                router.pathname == '/register/journalist'
                                    ? [
                                          styles['controls__item'],
                                          styles['controls__item--active'],
                                      ].join(' ')
                                    : styles['controls__item']
                            }
                        >
                            Journalist
                        </a>
                    </div>
                )}
                <div className={['border-accent', styles.body].join(' ')}>
                    <h2 dangerouslySetInnerHTML={{ __html: form.title }} />

                    {form.walkthrough && (
                        <p className={styles.walkthrough}>{form.walkthrough}</p>
                    )}
                    <div className={styles.bodyWrapper}>
                        <div className={styles.bodyForm}>
                            <form
                                method="post"
                                onSubmit={reCaptchaOnSubmitProxy}
                            >
                                {inputs}
                            </form>

                            {form.helper && (
                                <p className={styles.helper}>{form.helper}</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.sidebar}>
                {sidebar?.topTips &&
                    sidebar.topTips.map((item, index) => (
                        <BoxTopTip key={index} data={item} />
                    ))}

                {sidebar?.box && <Box data={sidebar.box} />}

                <div className={styles.sidebarQuote}>
                    <Quote quote={sidebar.quote} />
                </div>
            </div>
        </div>
    );
};

const RecaptchaWrapper = (props) => {
    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={process.env.GOOGLE_RECAPTCHA_SITE_TOKEN}
        >
            <FormWithSidebar {...props} />
        </GoogleReCaptchaProvider>
    );
};

export default RecaptchaWrapper;
